import {
  Component,
  DestroyRef,
  effect,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NavigationEnd, Router } from '@angular/router';
import {
  CommunicationService,
  CompanyService,
  getSafeImageUrl,
  ProjectService,
  ScreenService,
} from '@app/core';
import { User } from '../../models/partner/user';
import { AuthService } from '../../../core/services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Company } from '../../models/companies';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-sidebar',
  standalone: false,

  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.less',
})
export class SidebarComponent implements OnInit {
  @Input() isDetailRoute: boolean = false;

  public readonly oidcSecurityService = inject(OidcSecurityService);

  getSafeImageUrl = getSafeImageUrl;

  isCollapsed = true;
  isMobile$: any = null;

  currentRouteLabel: string = '';

  inboxNotification = 0;
  private destroyRef = inject(DestroyRef);

  loggedUser: User | undefined;
  loggedUserInitials: string = '';

  selectedCompany: Company | undefined;
  selectedCompanyInitials: string = '';
  selectedCompanyIds: number[] = [];
  operatingCompanyId: number | undefined;
  pendingSelectedCompanyIds: number[] = [];
  pendingOperatingCompanyId: number | undefined;
  companyDropdownVisible = false;

  menuItems = [
    {
      label: 'Contactos',
      icon: 'handshake',
      route: 'maestro/partner',
      color: '#0068D6',
    },
    {
      label: 'Leads',
      icon: 'patient_list',
      route: 'opportunities/leads',
      color: '#297A3A',
    },
    {
      label: 'Oportunidades',
      icon: 'person',
      route: 'opportunities',
      color: '#0068D6',
    },
    {
      label: 'Proyectos',
      icon: 'folder_copy',
      route: 'project',
      color: '#8E4EC6',
    },
    {
      label: 'Cotizaciones',
      icon: 'account_balance_wallet',
      route: 'opportunities/budgets',
      color: '#0068D6',
    },

    //#F9F1FE
    {
      label: 'Notificaciones',
      icon: 'notifications',
      route: 'inbox',
      color: '#EA3E83',
      },
    {
      label: 'Actividades',
      icon: 'task',
      route: 'activities',
      color: '#F5A623',
    },
    /* {
      label: 'Administración',
      icon: 'monitoring',
      route: 'administration',
      color: '#FF990A',
    }, */
    // {label: 'Documentos', icon: 'description', route: 'documents'},
    // {label: 'Catálogos', icon: 'auto_stories', route: 'catalog'},
    //{ label: 'Usuarios', icon: null, route: 'user', color: '#12A594' },
    // {label: 'Configuración', icon: null, route: 'configuration'},
  ];

  maestrosSubmenuItems = [
    // { label: 'Conductores', icon: 'home', route: 'driver' },
    { label: 'Usuarios', icon: 'home', route: 'user' },
    { label: 'Compañias', icon: 'home', route: 'company' },
    { label: 'Estados de contacto', icon: 'home', route: 'state' },
    { label: 'Tipos de contacto', icon: 'home', route: 'partner-type' },
    // { label: 'Etiquetas', icon: 'home', route: 'tag' },
    { label: 'Actividades', icon: 'home', route: 'activity-type' },
    { label: 'Centro de costo', icon: 'home', route: 'cost-center' },
    { label: 'Razón de pérdida', icon: 'home', route: 'loss-reason' },

    { label: 'Localizaciones', icon: 'pin_drop', route: 'location' },
    { label: 'Tipos de Localización', icon: 'pin_drop', route: 'location-type',},


    { label: 'Países', icon: 'south_america', route: 'country' },
    { label: 'Monedas', icon: 'home', route: 'currency' },
    { label: 'Equipos', icon: 'home', route: 'sales-team' },

    //  { label: 'Navieras', icon: 'box', route: 'shipping' },
    //  { label: 'Motonaves', icon: 'box', route: 'motonave' },
    //  { label: 'Mercancías', icon: 'box', route: 'good' },
    //{ label: 'Equipos', icon: 'box', route: 'equipment' },
    // { label: 'Tipos de Transportes', icon: 'home', route: 'transport-type' },
    // { label: 'Tipos de Paquete', icon: 'box', route: 'package-type' },

    { label: 'Flujos', icon: 'flow', route: 'flow' },
    { label: 'Tipos de tarea', icon: 'home', route: 'task-type' },
    {
      label: 'Tipos de Documento',
      icon: 'description',
      route: 'document-type',
    },
    { label: 'Etapas', icon: 'home', route: 'stages' },
    { label: 'Productos', icon: 'home', route: 'products' },
    { label: 'Unidad de Medida', icon: 'home', route: 'unit-of-measure' },
    {
      label: 'Categoría de Unidad de Medida',
      icon: 'home',
      route: 'unit-of-measure-category',
    },
    { label: 'Impuestos de Compañía', icon: 'home', route: 'company-taxes' },

    // { label: 'Tipos de Tarifa', icon: 'home', route: 'fee-type' },
    // { label: 'Tarifas', icon: 'home', route: 'fee' },
  ];
  groupedMaestrosSubmenuItems: any[][] = [
    this.maestrosSubmenuItems.slice(0, 9),
    this.maestrosSubmenuItems.slice(9, 11),
    this.maestrosSubmenuItems.slice(11),
    // this.maestrosSubmenuItems.slice(19),
  ];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private mobileService: ScreenService,
    private authService: AuthService,
    private projectService: ProjectService,
    private companyService: CompanyService,
    private communicationService: CommunicationService
  ) {
    authService.loggedUser.pipe(takeUntilDestroyed()).subscribe({
      next: (value) => {
        if (value) {
          const previousUserId = this.loggedUser?.id;

          this.loggedUser = value;
          this.loggedUserInitials = this.computeLoggedUserInitials(value);

          // Intentar restaurar selección múltiple primero
          const storageCompanyIdsRaw = localStorage.getItem('companyIds');
          if (storageCompanyIdsRaw) {
            try {
              const storedIds: number[] = JSON.parse(storageCompanyIdsRaw);
              const validIds = storedIds.filter((id) =>
                this.loggedUser!.companies.some((c) => c.id === id)
              );
              if (validIds.length !== storedIds.length) {
                localStorage.setItem('companyIds', JSON.stringify(validIds));
              }
              if (validIds.length > 0) {
                // Restaurar filtro de compañías
                this.selectedCompanyIds = validIds;
                this.companyService.selectedCompanyIds = validIds;

                // Restaurar compañía donde se está operando (independiente del filtro)
                // La fuente de verdad es companyId en localStorage
                const storedOperatingId = localStorage.getItem('companyId');
                const operatingId = storedOperatingId
                  ? parseInt(storedOperatingId, 10)
                  : validIds[0];
                const operatingCompany = this.loggedUser!.companies.find(
                  (c) => c.id === operatingId
                ) || this.loggedUser!.companies.find(
                  (c) => c.id === validIds[0]
                );

                this.operatingCompanyId = operatingCompany?.id;
                this.companyService.operatingCompanyId = operatingCompany?.id!;
                this.selectedCompany = operatingCompany;
                this.selectedCompanyInitials = this.computeCompanyInitials(
                  this.selectedCompany
                );

                // Garantizar que la compañía operativa siempre esté en selectedCompanyIds
                if (operatingCompany && !this.selectedCompanyIds.includes(operatingCompany.id)) {
                  this.selectedCompanyIds = [...this.selectedCompanyIds, operatingCompany.id];
                  localStorage.setItem('companyIds', JSON.stringify(this.selectedCompanyIds));
                  this.companyService.selectedCompanyIds = this.selectedCompanyIds;
                }

                this.resetPendingCompanySelection();

                if (previousUserId !== value.id) {
                  this.updateInboxNotifications();
                }
                return;
              }
            } catch {
              // Si el JSON es inválido, continuar con el fallback
            }
          }

          // Fallback: selección única desde localStorage
          const storageCompanyId = localStorage.getItem('companyId');
          const storageCompany = this.loggedUser!.companies.find(
            (c) => c.id.toString() === storageCompanyId
          );

          this.selectCompany(storageCompany || this.loggedUser!.companies[0]);
          if (previousUserId !== value.id) {
            this.updateInboxNotifications();
          }
        }
      },
      error: (e) => console.error(e),
    });
    // toObservable(this.communicationService.refreshNeeded).pipe(takeUntilDestroyed())
    //   .subscribe(()=>this.updateInboxNotifications())
    effect(() => {
      const refreshCount = this.communicationService.refreshNeeded();
      this.updateInboxNotifications();
    });
  }

  ngOnInit(): void {
    this.isMobile$ = this.mobileService.isMobile$;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        const currentPath = currentUrl.split('/').pop(); // Obtiene la última parte de la URL
        const menuItems = [
          ...this.menuItems,
          ...this.maestrosSubmenuItems,
          { label: 'Búsqueda', icon: '', route: 'search' },
        ];
        // Buscar primero rutas más específicas (ordenadas por longitud descendente)
        const sortedMenuItems = menuItems.sort(
          (a, b) => b.route.length - a.route.length
        );

        let foundItem = sortedMenuItems.find(
          (item) =>
            currentUrl.includes('/' + item.route) &&
            (currentUrl.endsWith('/' + item.route) ||
              currentUrl.endsWith('/' + item.route + '/'))
        );

        // Si no encuentra coincidencia exacta, buscar por inclusión
        if (!foundItem) {
          foundItem = sortedMenuItems.find((item) =>
            currentUrl.includes('/' + item.route)
          );
        }

        // Último recurso: buscar por última parte de la URL
        if (!foundItem) {
          foundItem = menuItems.find((item) => item.route === currentPath);
        }
        if (!foundItem) {
          // Buscar por variaciones comunes (project/projects)
          foundItem = menuItems.find(
            (item) =>
              item.route === 'project' &&
              (currentPath === 'projects' || currentUrl.includes('/projects'))
          );
        }
        this.currentRouteLabel = foundItem ? foundItem.label : 'Desconocido';
      }
    });
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  selectCompany(company: Company): void {
    localStorage.setItem('companyId', company.id.toString());
    // Al seleccionar una única compañía, inicializar la selección múltiple con solo esa
    this.selectedCompanyIds = [company.id];
    localStorage.setItem('companyIds', JSON.stringify([company.id]));
    this.companyService.selectedCompanyIds = [company.id];
    this.companyService.operatingCompanyId = company.id;
    this.operatingCompanyId = company.id;
    this.selectedCompany = company;
    this.selectedCompanyInitials = this.computeCompanyInitials(company);
    this.resetPendingCompanySelection();
  }

  toggleCompanySelection(company: Company): void {
    const idx = this.pendingSelectedCompanyIds.indexOf(company.id);
    if (idx === -1) {
      // Agregar compañía al filtro
      this.pendingSelectedCompanyIds = [...this.pendingSelectedCompanyIds, company.id];
    } else {
      // No permitir desmarcar la compañía donde se está operando
      if (company.id === this.pendingOperatingCompanyId) {
        return;
      }
      // Quitar compañía del filtro — pero no permitir dejar la lista vacía
      if (this.pendingSelectedCompanyIds.length === 1) {
        return;
      }
      this.pendingSelectedCompanyIds = this.pendingSelectedCompanyIds.filter(
        (id) => id !== company.id
      );
    }
  }

  isCompanySelected(company: Company): boolean {
    return this.pendingSelectedCompanyIds.includes(company.id);
  }

  isOperatingCompany(company: Company): boolean {
    return this.pendingOperatingCompanyId === company.id;
  }

  isCompanySelectionLocked(company: Company): boolean {
    return (
      this.isOperatingCompany(company) ||
      (this.isCompanySelected(company) && this.pendingSelectedCompanyIds.length === 1)
    );
  }

  setOperatingCompany(company: Company, event?: MouseEvent): void {
    event?.stopPropagation();

    if (this.isOperatingCompany(company)) {
      return;
    }

    this.pendingOperatingCompanyId = company.id;

    if (!this.pendingSelectedCompanyIds.includes(company.id)) {
      this.pendingSelectedCompanyIds = [...this.pendingSelectedCompanyIds, company.id];
    }
  }

  onCompanyDropdownVisibleChange(visible: boolean): void {
    this.companyDropdownVisible = visible;
    if (visible) {
      this.resetPendingCompanySelection();
    }
  }

  resetPendingCompanySelection(): void {
    this.pendingSelectedCompanyIds = [...this.selectedCompanyIds];
    this.pendingOperatingCompanyId = this.operatingCompanyId;
  }

  hasPendingCompanyChanges(): boolean {
    return (
      this.pendingOperatingCompanyId !== this.operatingCompanyId ||
      !this.areCompanyIdsEqual(this.pendingSelectedCompanyIds, this.selectedCompanyIds)
    );
  }

  confirmCompanySelection(): void {
    if (!this.pendingOperatingCompanyId) return;

    const operatingCompany = this.loggedUser?.companies.find(
      (company) => company.id === this.pendingOperatingCompanyId
    );
    if (!operatingCompany) return;

    const nextCompanyIds = this.pendingSelectedCompanyIds.includes(operatingCompany.id)
      ? [...this.pendingSelectedCompanyIds]
      : [...this.pendingSelectedCompanyIds, operatingCompany.id];

    const operatingChanged = operatingCompany.id !== this.operatingCompanyId;
    const companyIdsChanged = !this.areCompanyIdsEqual(nextCompanyIds, this.selectedCompanyIds);

    this.operatingCompanyId = operatingCompany.id;
    this.selectedCompanyIds = nextCompanyIds;
    this.selectedCompany = operatingCompany;
    this.selectedCompanyInitials = this.computeCompanyInitials(operatingCompany);

    if (operatingChanged) {
      localStorage.setItem('companyId', operatingCompany.id.toString());
      this.companyService.operatingCompanyId = operatingCompany.id;
    }

    if (companyIdsChanged) {
      localStorage.setItem('companyIds', JSON.stringify(nextCompanyIds));
      this.companyService.selectedCompanyIds = nextCompanyIds;
    }

    this.resetPendingCompanySelection();
    this.companyDropdownVisible = false;
  }

  private areCompanyIdsEqual(first: number[], second: number[]): boolean {
    if (first.length !== second.length) return false;

    const sortedFirst = [...first].sort((a, b) => a - b);
    const sortedSecond = [...second].sort((a, b) => a - b);

    return sortedFirst.every((id, index) => id === sortedSecond[index]);
  }

  private computeCompanyInitials(company: Company | undefined): string {
    if (!company) return '?';
    return company.name
      .split(/\s+/)
      .filter((word) => word.length > 0)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  /**
   * Calcula las iniciales del usuario usando partner.name y partner.surName.
   * Fallback: usa loggedUser.name/surName si existen; de lo contrario retorna '?'.
   */
  private computeLoggedUserInitials(user: User | null | undefined): string {
    if (!user) return '?';

    const partner = (user as any)?.partner;
    let name = partner?.name || (user as any).name || '';
    let surName = partner?.surName || (user as any).surName || '';

    let initials = '';
    if (name && name.trim()) {
      initials += name.trim().charAt(0).toUpperCase();
    }
    if (surName && surName.trim()) {
      initials += surName.trim().charAt(0).toUpperCase();
    }

    return initials || '?';
  }

  private updateInboxNotifications(): void {
    if (!this.loggedUser) return;

    this.communicationService
      .getPendingNotification(this.loggedUser.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (value) => {
          value.data.rows
            ? (this.inboxNotification = value.data.rows.filter(
                (not) => !not.isRead
              ).length)
            : (this.inboxNotification = 0);
        },
        error: (err) => console.error('Error loading notifications', err),
      });
  }

  logout() {
    this.oidcSecurityService
      .logoff()
      .subscribe((result) => console.log(result));
  }
}
